export default {
  name: 'button',
  component_path: 'modules/procedures/blocks/static/BlockButton'
}